<template>
  <!-- 空状态 -->
  <div class="empty dis_f_c_c">
    <div class="dis_f_co_c_c">
      <div class="emptyImg">
        <img class="fit" src="@/images/common/empty.png" alt="" />
      </div>
      <div class="title">{{ title }}</div>
      <div class="look hand" v-if="type" @click="call">前去查看</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    // 状态 1询盘 2发布的现舱
    type: {
      type: Number,
      // default: "",
    },
    // 信息
    title: {
      type: String,
      default: "暂无查询信息，可更换信息查询或者稍后查询~",
    },
  },
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  created() {},
  methods: {
    call(){
      if(this.type == 1){
        this.$router.push('/lookPresentCabin')
      }else if(this.type == 2){
        this.$router.push('/currentCabinHall')
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variable.scss";
// 空状态
.empty {
  width: 100%;
  min-height: calc(100vh - #{$workNavbarHeight} - #{$workFooterHeight} - 34px);
  background-color: #ffffff;
  border-radius: 12px;
  .emptyImg {
    width: 296px;
    height: 246px;
    margin-bottom: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #676b76;
  }
  .look {
    width: 84px;
    height: 30px;
    background: var(--themeColor);
    border-radius: 4px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>